import {
  Star, MapPin, MessageCircle, Globe, Instagram, Music2, Ghost, Contact2,
  Phone, Link2, CalendarCheck, ShoppingBag, ChevronRight,
} from "lucide-react";

export const ICONS = {
  star: Star,
  "map-pin": MapPin,
  "message-circle": MessageCircle,
  globe: Globe,
  instagram: Instagram,
  music: Music2,
  ghost: Ghost,
  contact: Contact2,
  phone: Phone,
  link: Link2,
  calendar: CalendarCheck,
  "shopping-bag": ShoppingBag,
};

export const ICON_CHOICES = Object.keys(ICONS);

export function ButtonIcon({ icon, className = "h-5 w-5" }) {
  const Icon = ICONS[icon] || Link2;
  return <Icon className={className} />;
}

// Rendu partagé : page publique NFC et prévisualisations admin/commerçant.
export function NfcPageView({ page, onButtonClick, preview = false }) {
  const buttons = (page.buttons || [])
    .filter((b) => b.enabled !== false && (b.url || b.key === "vcard"))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return (
    <div className="flex min-h-full flex-col items-center bg-nuit-950 px-5 pb-10 pt-12 text-white">
      {page.logo ? (
        <img src={page.logo} alt={`Logo ${page.business_name}`} className="h-20 w-20 rounded-3xl object-cover shadow-lg" />
      ) : (
        <span className="flex h-20 w-20 items-center justify-center rounded-3xl bg-electric font-display text-3xl font-bold text-white shadow-lg">
          {(page.business_name || "?").charAt(0).toUpperCase()}
        </span>
      )}
      <h1 className="mt-5 text-center font-display text-2xl font-bold tracking-tight">
        {page.business_name}
      </h1>
      {page.description && (
        <p className="mt-2 max-w-xs text-center text-sm leading-relaxed text-white/60">{page.description}</p>
      )}

      <div className="mt-8 flex w-full max-w-sm flex-col gap-3">
        {buttons.map((b) => (
          <button
            key={b.key}
            type="button"
            onClick={() => onButtonClick?.(b)}
            data-testid={preview ? `preview-btn-${b.key}` : `nfc-btn-${b.key}`}
            className="group flex w-full items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.06] px-5 py-4 text-left transition-colors duration-300 hover:border-electric/60 hover:bg-white/10 active:scale-[0.99]"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-electric/15 text-electric-300">
              <ButtonIcon icon={b.icon} />
            </span>
            <span className="flex-1 font-display text-[15px] font-semibold">{b.label}</span>
            <ChevronRight className="h-4 w-4 text-white/40 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        ))}
        {buttons.length === 0 && (
          <p className="rounded-2xl border border-white/10 bg-white/5 p-5 text-center text-sm text-white/60">
            Aucun lien activé pour le moment.
          </p>
        )}
      </div>

      <a
        href="/"
        className="mt-12 text-[11px] font-medium uppercase tracking-[0.25em] text-white/35 transition-colors hover:text-white/70"
      >
        Carte digitale · Noveocard
      </a>
    </div>
  );
}

// Prévisualisation dans un cadre de téléphone (admin + espace commerçant).
export default function PagePreview({ page }) {
  return (
    <div className="mx-auto w-full max-w-[300px]" data-testid="page-preview">
      <div className="phone-mock !border-nuit-900/20 p-1.5">
        <div className="h-[520px] overflow-y-auto rounded-[1.6rem]">
          <NfcPageView page={page} preview onButtonClick={() => {}} />
        </div>
      </div>
      <p className="mt-3 text-center text-[11px] font-medium uppercase tracking-[0.18em] text-steel">
        Aperçu mobile en direct
      </p>
    </div>
  );
}
